import ReactGA from "react-ga4";

//console.log("Analytics.js module loaded successfully");

const MEASUREMENT_ID = "G-GW5QVN34X2";
let userOrganization = null;
let currentUserId = null;

/**
 * Sanitize organization name for use in event actions (lowercase, snake_case)
 * @param {string} org - The organization name
 * @returns {string} - Sanitized organization name or empty string
 */
const getSanitizedOrg = (org) => {
  if (!org) return "";
  return "_" + org.toLowerCase().replace(/[\s-]+/g, "_");
};

/**
 * Initialize Google Analytics 4
 */
export const initGA = () => {
  ReactGA.initialize(MEASUREMENT_ID);
  //console.log("GA4 Initialized with ID:", MEASUREMENT_ID);
};

/**
 * Track Page Views
 * @param {string} path - The URL path to track
 */
export const trackPageView = (path) => {
  const orgSuffix = getSanitizedOrg(userOrganization);
  const taggedPath = path + orgSuffix;

  ReactGA.send({
    hitType: "pageview",
    page: taggedPath,
    user_id: currentUserId,
    organization: userOrganization,
  });
  //console.log("GA4 PageView tracked:", {
  //   path: taggedPath,
  //   user_id: currentUserId,
  //   organization: userOrganization,
  // });
};

/**
 * Set User Data for identification
 * @param {string} userId - User's primary identifier (e.g., UUID)
 * @param {string} firstName - User's first name
 * @param {string} organization - User's organization
 */
export const setUserData = (userId, firstName, organization) => {
  // Set primary user ID
  ReactGA.set({
    user_id: userId,
  });

  // Set user properties
  ReactGA.set({
    user_properties: {
      first_name: firstName,
      organization: organization,
    },
  });

  // Cache data for trackEvent and trackPageView
  currentUserId = userId;
  userOrganization = organization;

  //console.log("GA4 User data set:", {
  //   user_id: userId,
  //   first_name: firstName,
  //   organization,
  // });
};

/**
 * Track custom events
 * @param {string} action - The action name (e.g., 'click_fees')
 * @param {string} category - The event category (e.g., 'engagement')
 * @param {string} label - A descriptive label for the event
 * @param {string} [org] - Optional organization override
 */
export const trackEvent = (action, category, label, org) => {
  const finalOrg = org || userOrganization;
  const orgSuffix = getSanitizedOrg(finalOrg);
  const taggedAction = action + orgSuffix;

  //console.log("Analytics: trackEvent called", {
  //   action: taggedAction,
  //   category,
  //   label,
  //   organization: finalOrg,
  //   user_id: currentUserId,
  // });
  try {
    ReactGA.event(taggedAction, {
      category,
      label,
      user_id: currentUserId,
      organization: finalOrg,
    });
    //console.log("GA4 Event tracked successfully:", {
    //   action: taggedAction,
    //   category,
    //   label,
    //   organization: finalOrg,
    //   user_id: currentUserId,
    // });
  } catch (error) {
    console.error("GA4 Event tracking failed:", error);
  }
};
